import React from "react";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import { runInnerFunction } from "../../compatManager";
import { getLawyerFirstName, getLawyerLastName, getLawyerNode } from "../../livedataFuncs";
import { DropdownArrayObj } from "../fileToolbarConsts";
import { formatAMPM, lawyerInitialsFuncs, LocalYearMonthDayHourMinuteString, replyToNoteFunc } from "../fileToolbarFuncs";
import { RightMenuReplyTextAreaType } from "../fileToolbarTypes";
import Form from 'react-bootstrap/Form';
import DropdownToggle from "../../Components/DropdownToggle";
import { Avatar } from "../../Components/ui/avatar/avatar";

interface IState {
    index: number,
    boxPlaceHolder: string,
    boxText: string,
    currentDateHoursMinutes: string,
    LocalDate: string,
    noteType: string,
}

interface IProps {
    dataroot: any,
    ReplyBoxType: string,
    index: number,
    showReplyBoxMessage: string,
    displayBoxHandler: (value: boolean) => void,
    noteDropdownState: string,
}
// text area for reply
export class MainNoteItemTextBox extends React.Component<IProps, IState>{
    constructor(props: IProps) {
        super(props);
        let currDate = new Date();
        let UTCDateHolder = LocalYearMonthDayHourMinuteString();
        let timeHourMinuteAMPM = formatAMPM(currDate);

        this.state = {
            index: props.index,
            boxPlaceHolder: props.showReplyBoxMessage,
            boxText: '',
            currentDateHoursMinutes: timeHourMinuteAMPM,
            LocalDate: UTCDateHolder,
            noteType: props.noteDropdownState === 'All' ? 'General' : props.noteDropdownState,
        }
    }
    setTextbox = (text: string) => {
        this.setState({
            boxText: text
        })
    }

    setDateState = () => {
        let currDate = new Date();
        let timeHourMinuteAMPM = formatAMPM(currDate);
        if (timeHourMinuteAMPM !== this.state.currentDateHoursMinutes) {
            this.setState({
                currentDateHoursMinutes: timeHourMinuteAMPM,
                LocalDate: LocalYearMonthDayHourMinuteString(),
            })
        }
    }

    handleDropdownSelect = (selectedType: string) => {
        this.setState({
            noteType: selectedType
        });
    }

    render(): React.ReactNode {
        let lawyerNode = getLawyerNode(this.props);
        let lawyerFirstNameHolder = getLawyerFirstName(lawyerNode);
        let lawyerLastNameHolder = getLawyerLastName(lawyerNode);
        let lawyerInitialsHolder = lawyerInitialsFuncs(lawyerFirstNameHolder, lawyerLastNameHolder);
        return (
            <div key={`Main-Note-Item-Text-Box-${this.props.index}-${this.props.ReplyBoxType}`} className="note">
                {this.props.ReplyBoxType !== 'Reply' &&
                    <>
                        <div className="new-note-header">
                            <Row className="gx-0">
                                <Col className="col-md-auto">
                                    <Avatar initials={lawyerInitialsHolder} />
                                </Col>
                                <Col>
                                    <h3>{lawyerFirstNameHolder} {lawyerLastNameHolder}</h3>
                                    <Form.Label>{this.state.currentDateHoursMinutes}</Form.Label>
                                </Col>
                            </Row>
                        </div>

                        <div style={{paddingBottom: '0'}}>
                            <Row className="gx-0">
                                <Col className="col-md-auto">
                                    {this.props.ReplyBoxType === 'Add' && this.props.noteDropdownState === 'All' && (
                                        <>
                                            <Dropdown onSelect={this.handleDropdownSelect}>
                                                <Dropdown.Toggle as={DropdownToggle}>
                                                    {this.state.noteType}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {Object.keys(DropdownArrayObj.mainScreenNameIndex).filter(option => option !== 'All').map(option => (
                                                        <Dropdown.Item key={option} eventKey={option}>
                                                            {option}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        </div>
                    </>
                }

                {this.props.ReplyBoxType === 'Reply' &&
                    <>
                        <this.RightMenuReplyTextArea boxType={'replybox'} index={this.props.index} />
                
                        <div className="note-toolbar">
                            <Button variant="text" size="sm" onClick={() => {
                                this.props.displayBoxHandler(false);
                            }}>Cancel</Button>

                            {this.state.boxText.length > 0 ?
                                <Button variant="primary" size="sm" onClick={() => {
                                    replyToNoteFunc(this.props, this.props.index);
                                    this.props.displayBoxHandler(false);
                                }}><i className="fa-solid fa-paper-plane-top"></i></Button>
                                :
                                <Button variant="secondary" size="sm" onClick={() => {
                                    replyToNoteFunc(this.props, this.props.index);
                                    this.props.displayBoxHandler(false);
                                }} disabled><i className="fa-solid fa-paper-plane-top"></i></Button>
                            }
                        </div>
                    </>
                }

                {this.props.ReplyBoxType === 'Add' &&
                    <div>
                        <this.RightMenuReplyTextArea boxType={'addnote'} index={this.props.index} />
                        <div className="note-toolbar">
                            <Button variant="text" size="sm" onClick={() => {
                                this.props.displayBoxHandler(false);
                            }}>Cancel</Button>

                            {this.state.boxText.length > 0 ?
                                <Button variant="primary" size="sm" onClick={() => {
                                    const paramArray: string[] = [
                                        this.state.boxText,
                                        lawyerFirstNameHolder,
                                        lawyerLastNameHolder,
                                        lawyerInitialsHolder,
                                        this.state.LocalDate,
                                        DropdownArrayObj.mainScreenNames[DropdownArrayObj.mainScreenNameIndex[this.state.noteType === 'All' ? "General" : this.state.noteType]]];
                                    runInnerFunction('createXMLElementAndAddToLiveDataRoot', paramArray);
                                    this.props.displayBoxHandler(false);
                                }}><i className="fa-solid fa-paper-plane-top"></i></Button>
                                :
                                <Button variant='secondary' disabled size="sm"><i className="fa-solid fa-paper-plane-top"></i></Button>
                            }
                        </div>
                    </div>
                }
            </div>
        )
    }

    RightMenuReplyTextArea = (props: RightMenuReplyTextAreaType) => {
        return (
            <Form.Control
                as="textarea"
                placeholder={this.props.showReplyBoxMessage}
                name={`${props.boxType}-${props.index}`}
                cols={30}
                onChange={(event) => {
                    this.setTextbox(event.target.value)
                    this.setDateState();
                }}>
            </Form.Control>
        )
    }
}